'use strict';

import { CONST } from 'app_vodafone_ziggo/util/util';

const mainContainer = document.querySelector('.js-bscan-main');

const gtmOptOut = 'data-bscan-gtm-opt-out';
const attrStepId = 'data-bscan-step-id';
const attrResourceIncomplete = 'data-bscan-resource-incomplete';

/**
 * @public sendGtmRouteChangeEvent
 * @param {string} stepName - The step's name
 * @description
 * Will send an event to GTM with the current route
 */
function sendGtmRouteChangeEvent(stepName) {
    // This if statement means we're not inside the BScan
    if (!mainContainer) {
        return;
    }

    const optOut = mainContainer.getAttribute(gtmOptOut) !== null;

    /* eslint no-underscore-dangle: ["error", { "allow": ["_ddm"] }] */
    if (optOut || !window._ddm || !stepName) {
        return;
    }

    /* eslint no-underscore-dangle: ["error", { "allow": ["_ddm"] }] */
    window._ddm.trigger('routeChange.ready', {
        data: {
            page: {
                route: stepName
            }
        }
    });
}

/**
 * @public appendDataToName
 * @param {string} targetStepId - The target step's id
 * @param {string} targetStepName - The target step's name
 * @param {string} currentStepName - The current step's name
 * @returns {string} - An updated targetStepName
 * @description
 * Will append data to the name to create unique step names for GTM
 */
function appendDataToName(targetStepId, targetStepName, currentStepName) {
    let updatedName = targetStepName;

    // On the thank you page, append the previous step's name to make the title unique
    if (targetStepId === CONST.bscanSteps.THANKYOU) {
        updatedName = `${targetStepName}-${currentStepName.toLowerCase().replace(/\s/g, '-')}`;
    }

    // If the user has skipped the statements, append a string to make the title unique
    if (window.skipStatements && targetStepId === CONST.bscanSteps.STATEMENTS_DONE) {
        const targetStep = document.querySelector(`[${attrStepId}="${targetStepId}"]`);
        const resourceIncomplete = targetStep && targetStep.getAttribute(attrResourceIncomplete).toLowerCase();

        updatedName = `${targetStepName}-${resourceIncomplete}`;
    }

    return updatedName;
}

export { sendGtmRouteChangeEvent, appendDataToName };
